import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDescription = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 20,
	viewBox: "0 -960 960 960",
	width: 20,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M336-240h288v-72H336v72Zm0-144h288v-72H336v72ZM263.717-96Q234-96 213-117.15T192-168v-624q0-29.7 21.15-50.85Q234.3-864 264-864h312l192 192v504q0 29.7-21.162 50.85Q725.676-96 695.96-96H263.717ZM528-624v-168H264v624h432v-456H528ZM264-792v189-189 624-624Z" })
});
export default SvgDescription;
